<div class="channel-house-list">
  <div class="search">
    <nz-input-group nzSearch style="height: 32px;" [nzSuffix]="suffixButton">
      <input
        type="text"
        nz-input
        [(ngModel)]="title"
        placeholder="{{ 'placeholder.house_name' | translate }}"
        (keyup.enter)="page = 1; fetchHouseList()"
        style="font-size: 12px; color: #b8b8b8; letter-spacing: 0.2px;"
      />
    </nz-input-group>
    <ng-template #suffixButton>
      <button
        nz-button
        nzType="primary"
        style="height: 32px; font-size: 12px;"
        nzSearch
        (click)="page = 1; fetchHouseList()"
      >
        <!-- 搜索 -->
        {{ "word.search" | translate }}
      </button>
    </ng-template>
  </div>
  <div class="list">
    <div class="cards">
      <nz-radio-group class="group" [(ngModel)]="selected">
        <div class="card" *ngFor="let house of houseList; index as i">
          <div *ngIf="i % 2 === 0">
            <label nz-radio [nzValue]="house?.id" style="width: 20px;"></label>
          </div>
          <div class="container">
            <div class="top">
              <div class="pic">
                <img
                  hostPlaceholder
                  src="/assets/status/placeholder.png"
                  [attr.data-src]="house.__picture"
                />
              </div>
              <div class="info">
                <p class="title" [attr.title]="house?.__title">
                  {{ house?.__title }}
                </p>
                <p class="address">{{ house?.__address }}</p>
              </div>
            </div>
            <div class="bottom">
              <span>
                <!-- 相关渠道： -->
                {{ "order.change_to_which_house.related_channel" | translate }}
              </span>
              <div *ngFor="let platform of house.platforms">
                <div *ngIf="house?.__type?.includes(platform?.type)">
                  <img [src]="platform?.icon" class="platform-logo" />
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="i % 2 === 1">
            <label nz-radio [nzValue]="house?.id" style="width: 20px;"></label>
          </div>
        </div>
      </nz-radio-group>
    </div>
  </div>
  <div class="pagination">
    <nz-pagination
      [nzTotal]="total"
      [(nzPageIndex)]="page"
      [nzPageSize]="pageSize"
      [nzSize]="'small'"
      [nzShowTotal]="totalTemplate"
      (nzPageIndexChange)="fetchHouseList()"
    ></nz-pagination>
    <ng-template #totalTemplate let-total>
      {{
        (total > 1 ? "order.total_houses" : "order.total_house")
          | translate: { total: total }
      }}
    </ng-template>
  </div>
  <div class="footer-bar">
    <button nz-button nzType="primary" (click)="onConfirm()">
      {{ "word.confirm" | translate }}
    </button>
  </div>
</div>
